import { GET } from "../../API/get";

export const fetchFtms = async (page_number, serach_text, sort_key, sort_direction) => {
    let url = `rejected/applications/${page_number}?search=${serach_text.trim()}&sort_key=${sort_key}&sort_direction=${sort_direction}`;
    let response = await GET(url);

    return response.status === "Success" ? response : null;
}